import { render, staticRenderFns } from "./SightMapAccessibilityButton.vue?vue&type=template&id=720b4b7a"
import script from "./SightMapAccessibilityButton.vue?vue&type=script&lang=js"
export * from "./SightMapAccessibilityButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports